exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3Q6p7JJQejMjTZnFjlMbJy{display:none}html[dir] ._1FFJLF3dErf7LjqP4lxU6O{border:solid 1px var(--neutralTertiary);padding:0 4px}html[dir] ._24-Tg0NOpjjVHtOPf2JyDf{border:solid 1px \"[theme:neutralTertiary, default:#a6a6a6]\";padding:0 4px}.iQHzKaAoipDMS2HnvMwjt{width:400px}", ""]);
// Exports
exports.locals = {
	"hideSubmit": "_3Q6p7JJQejMjTZnFjlMbJy",
	"iCloudCredentialPromptDialogText": "_1FFJLF3dErf7LjqP4lxU6O",
	"iCloudCredentialPromptDialogTextFallback": "_24-Tg0NOpjjVHtOPf2JyDf",
	"textbox": "iQHzKaAoipDMS2HnvMwjt"
};